import { projects as actionTypes } from '$constants/action-types';

export const fetchAll = params => ({
  type: actionTypes.FETCH_ALL,
  params
});

export const fetchAllRequest = () => ({
  type: actionTypes.FETCH_ALL_REQUEST
});

export const fetchAllSuccess = (result, hasMore) => ({
  type: actionTypes.FETCH_ALL_SUCCESS,
  result,
  hasMore
});

export const fetchAllFailure = errors => ({
  type: actionTypes.FETCH_ALL_FAILURE,
  errors
});

export const fetch = params => ({
  type: actionTypes.FETCH,
  params
});

export const fetchRequest = () => ({
  type: actionTypes.FETCH_REQUEST
});

export const fetchSuccess = (result) => ({
  type: actionTypes.FETCH_SUCCESS,
  result
});

export const fetchFailure = errors => ({
  type: actionTypes.FETCH_FAILURE,
  errors
});

export const clear = () => ({
  type: actionTypes.CLEAR
});

export const createReport = (fileType, filters) => ({
  type: actionTypes.CREATE_REPORT,
  fileType,
  filters
});



// WEBPACK FOOTER //
// ./src/actions/projects.js